import { AutoCompleteComponent } from '../../../../shared/components/auto-complete/auto-complete.component';
import { AutocompleteDirective } from '@shared/directives/autocomplete.directive';
import { AutocompleteService } from '@shared/services/autocomplete.service';
import { CommonModule, isPlatformBrowser } from '@angular/common';
import {
 AfterViewInit,
 Component,
 ElementRef,
 Inject,
 OnInit,
 PLATFORM_ID,
 ViewChild,
 computed,
 effect,
 inject,
 isSignal,
 signal,
} from '@angular/core';
import { DatepickerComponent } from '@shared/components/datepicker/datepicker.component';
import { DatepickerDirective } from '@shared/directives/datepicker.directive';
import { DatepickerService } from '@shared/services/datepicker.service';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatTabsModule } from '@angular/material/tabs';
import { ActivatedRoute, Router, RouterLinkActive, RouterModule } from '@angular/router';
import { SearchBoxService } from '@shared/services/serach-box.service';
import { SharedModule } from '@shared/shared.module';
import { SwiperOptions } from 'swiper';
import { WebengageService } from '@core/services/webengage.service';
import { HomeFlexModel, HomeModel } from '@models/home-page-flex';
import { HomeUiService } from '../../home-ui.service';

export enum Tabs {
 ecolodge,
 hotel,
 special
}

@Component({
 selector: 'iho-desktop-searchbox',
 templateUrl: './desktop-searchbox.component.html',
 styleUrls: ['./desktop-searchbox.component.scss'],
 providers: [],
 standalone: true,
 imports: [
  CommonModule,
  MatInputModule,
  SharedModule,
  MatTabsModule,
  MatFormFieldModule,
  MatButtonToggleModule,
  AutoCompleteComponent,
  AutocompleteDirective,
  DatepickerComponent,
  DatepickerDirective,
  RouterModule,
 ],
})
export class DesktopSearchboxComponent implements OnInit, AfterViewInit {
 router = inject(Router);
 route = inject(ActivatedRoute);
 autocompleteService = inject(AutocompleteService);
 datepickerService = inject(DatepickerService);
 searchBoxService = inject(SearchBoxService);
 @ViewChild('hotel', { static: true }) hotelSwitcherTab!: any;
 @ViewChild('ecolodge', { static: true }) ecolodgeSwitcherTab!: any;
  webengageService = inject(WebengageService);
  uiService = inject(HomeUiService);
 csrStatus = signal<any>(false);
 autocompleteValidate = false;
 startDateValidate = false;
 endDateValidate = false;
  isActiveTabsHomePage = computed(() => this.uiService.isActiveTab());
  isActivedataInitialized = computed(() => this.uiService.dataInitialized);
 activeAccomodationNavigator = signal({
  width: this.searchBoxService.accommodation() == 'ecolodge' ? 140 : 100,
   position: this.searchBoxService.accommodation() == 'ecolodge' ? 105 :
     this.searchBoxService.accommodation() == 'special' ? 260 : 0,
 });



 constructor(@Inject(PLATFORM_ID) private platformId: Object) {
  effect(
   () => {
    if (this.datepickerService._state() && isPlatformBrowser(this.platformId)) {
     this.csrStatus.set(DatepickerComponent);
    }
   },
   { allowSignalWrites: true }
  );
 

 }
 ngAfterViewInit(): void {
  this.activeAccomodationNavigator.set({
    position: this.searchBoxService.accommodation() == 'ecolodge' ? 105 :
      this.searchBoxService.accommodation() == 'villa-mashhad' ? 260 : 0,
    width: this.searchBoxService.accommodation() == 'villa-mashhad' ? 0 : this.activeAccomodationNavigator().width,
  });
 }

 ngOnInit(): void {
  this.autocompleteService.setSelectedItem([]);
  this.datepickerService.setCustomEndDate('');
  this.datepickerService.setCustomStartDate('');
  this.datepickerService.setEndDate('');
  this.datepickerService.setStartDate('');
 }

 /*
      - toggleTab
    */
 selectedTab = Tabs.hotel;
 toggleTab(event: { index: number; tab: unknown }) {
  this.selectedTab = event.index;
  switch (event.index) {
   case Tabs.hotel:
    this.router.navigate(['/home/hotel']);
    break;
   case Tabs.ecolodge:
    this.router.navigate(['/home/ecolodge']);
    break;
    case Tabs.special:
      this.router.navigate(['/home/villa-mashhad']);
      break;
  }
 }

 changeAccommodation(accommodationType: string, _width: number) {
  this.autocompleteService.setSelectedItem([]);
  this.searchBoxService.accommodation.set(accommodationType);
  this.activeAccomodationNavigator.set({
   position: this.searchBoxService.accommodation() == 'ecolodge' ? 105 :
      this.searchBoxService.accommodation() == 'special' ?  250 : 0,
   width: _width,
  });
 }

 /*
      - start fucking search
    */
  search() {
    if (isPlatformBrowser(this.platformId)) {
      window.scrollTo({ top: 0 });
    }
    let isValid = true;
    if (this.autocompleteService._selectedItem().id === undefined) {
      this.autocompleteValidate = true;
      isValid = false;
    } else {
      this.autocompleteValidate = false;
    }
    if (this.datepickerService._startDate() === '') {
      this.startDateValidate = true;
      isValid = false;
    } else {
      this.startDateValidate = false;
    }
    if (this.datepickerService._endDate() === '') {
      this.endDateValidate = true;
      isValid = false;
    } else {
      this.endDateValidate = false;
    }
    if (isValid) {
      let parameters = {
        id: this.autocompleteService._selectedItem().id,
        type: this.autocompleteService._selectedItem().type,
        link: this.autocompleteService._selectedItem().link,
        name: this.autocompleteService._selectedItem().name,
        state: this.autocompleteService._selectedItem().state ?? '',
        isShabAdsCode: this.autocompleteService._selectedItem().isShabAdsCode,
        startDate: this.datepickerService._startDate(),
        endDate: this.datepickerService._endDate(),
      };

      this.searchBoxService.triggerSearch(parameters, false, this.autocompleteService.adCode());
    }
  }
}
